import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  alarmFiltersSelector,
  getAlarmNotificationSound,
  refetchAlarmsData,
  selectAlarmEntities,
  updateSingleAlarmRow,
} from "./alarmsSlice";
import NotificationBellWAV from "../../assets/audio/notification_bell.wav";
import {
  ALARM_SOCKET,
  ALARM_WEBSOCKET_PATH,
  APP_BASE_URL_ALARM,
  APP_BASE_URL_ALARM_SOCKET,
} from "../../Common/EndPoints";
import { shouldInsertIntoTable } from "./alarmUtils";
import axios from "axios";
import toast from "react-hot-toast";
import NewAlarmToast from "./NewAlarmToast";

const audioWAV = new Audio(NotificationBellWAV);
var filters = null;
var entities = null;
var playAlarmSound = null;

/** Custom throttle function to avoid external dependency */

const throttle = (func, wait, options = { leading: true, trailing: true }) => {
  let timeout = null;
  let previous = 0;
  return function(...args) {
    const now = Date.now();
    if (!previous && options.leading === false) previous = now;
    const remaining = wait - (now - previous);
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      func.apply(this, args);
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(() => {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        func.apply(this, args);
      }, remaining);
    }
  };
};

const create_pac = {
  id: "2d4e1af2-14d6-4896-9acc-5ee48d82979b",
  created_dt: "2025-04-23T18:17:10.472806Z",
  clear_dt: null,
  ack_dt: null,
  type: "IPIS Unhealthy",
  category: "Failed",
  create_info: {
    desc: "link or component issue",
    proto: "SNMP",
    vendor: "IPIS",
  },
  device_id: "5e5bf9c0-f190-48ec-86c8-98c934026496",
  customer_id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
  acked_by: null,
  acked_info: null,
  is_active: true,
  severity: "CRITICAL",
  updated_dt: null,
  clear_info: null,
  event_count: 1,
  create_value: {
    component: "OK",
    ip: "192.168.0.132",
    link: "Failed",
  },
  clear_value: null,
  update_value: null,
  device: {
    id: "5e5bf9c0-f190-48ec-86c8-98c934026496",
    name: "NCR_PRYJ_MIU_DTMF-CHARGER-1",
    is_test_mode: false,
    device_type_id: "e8d8d063-f465-409d-8a8a-2a57f1019247",
    is_logical: false,
    software_id: "881c306f-f230-4d56-910f-c3e66c83ace8",
    latitude: 28.5875977,
    longitude: 77.4958595,
    customer: null,
    device_type: null,
    software: null,
  },
  customer: {
    id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
    zone: "NCR",
    division: "PRYJ",
    station: "MIU",
    title: null,
    devices: null,
  },
  acked_user: null,
  fmeas: null,
};
const clear_pac = {
  id: "2d4e1af2-14d6-4896-9acc-5ee48d82979b",
  created_dt: "2025-04-23T18:17:10.472806Z",
  clear_dt: "2025-04-23T18:18:14.089636Z",
  ack_dt: null,
  type: "IPIS Unhealthy",
  category: "Failed",
  create_info: {
    desc: "link or component issue",
    proto: "SNMP",
    vendor: "IPIS",
  },
  device_id: "5e5bf9c0-f190-48ec-86c8-98c934026496",
  customer_id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
  acked_by: null,
  acked_info: null,
  is_active: false,
  severity: "CRITICAL",
  updated_dt: null,
  clear_info: {
    desc: "link and component healthy",
    proto: "SNMP",
    vendor: "IPIS",
  },
  event_count: 1,
  create_value: {
    component: "OK",
    ip: "192.168.0.132",
    link: "Failed",
  },
  clear_value: {
    component: "OK",
    ip: "192.168.0.132",
    link: "Success",
  },
  update_value: null,
  device: {
    id: "5e5bf9c0-f190-48ec-86c8-98c934026496",
    name: "NCR_PRYJ_MIU_DTMF-CHARGER-1",
    is_test_mode: false,
    device_type_id: "e8d8d063-f465-409d-8a8a-2a57f1019247",
    is_logical: false,
    software_id: "881c306f-f230-4d56-910f-c3e66c83ace8",
    latitude: 28.5875977,
    longitude: 77.4958595,
    customer: null,
    device_type: null,
    software: null,
  },
  customer: {
    id: "499c0695-60b8-4d37-b7ee-42fa0a02ca1b",
    zone: "NCR",
    division: "PRYJ",
    station: "MIU",
    title: null,
    devices: null,
  },
  acked_user: null,
  fmeas: null,
};
const alarm_simulation_packet = [create_pac, clear_pac];
function playNotificationSound() {
  if (playAlarmSound) {
    audioWAV.play();
  }
}

export function useAlarmsWebsocket(connect, customerIdList) {
  const alarmEntities = useSelector(selectAlarmEntities);
  const alarmFilters = useSelector(alarmFiltersSelector);
  const alarmSound = useSelector(getAlarmNotificationSound);
  const dispatch = useDispatch();
  // const [alarmPacket, setAlarmPacket] = useState(null);

  const createAlarm = async () => {
    const alarm_url = `${APP_BASE_URL_ALARM}/alarm/create_payload`;
    const payload = {
      category: "Failed",
      device_id: "5e5bf9c0-f190-48ec-86c8-98c934026496",
      info: {
        desc: "link or component issue",
        proto: "SNMP",
        vendor: "IPIS",
      },
      severity: "CRITICAL",
      type: "Dummy Alarm",
      value: {
        component: "OK",
        ip: "192.168.0.132",
        link: "Failed",
      },
    };
    await axios.post(alarm_url, payload);
  };
  const clearAlarm = async () => {
    const alarm_url = `${APP_BASE_URL_ALARM}/alarm/clear_payload`;
    const payload = {
      device_id: "5e5bf9c0-f190-48ec-86c8-98c934026496",
      info: {
        desc: "link or component issue",
        proto: "SNMP",
        vendor: "IPIS",
      },
      type: "Dummy Alarm",
      value: {
        component: "OK",
        ip: "192.168.0.132",
        link: "Failed",
      },
    };
    await axios.post(alarm_url, payload);
  };

  useEffect(() => {
    /**
     * - this is done because in websocket latest value of state cannot be accessed
     * - as the value of state is saved at the time of creation of websocket
     * - thus creating global variables and saving state in them to access latest value of state
     * - useRef() can be used in replacement of this
     */
    filters = alarmFilters;
    entities = alarmEntities;
    playAlarmSound = alarmSound;
  }, [alarmEntities, alarmFilters, alarmSound]);

  const throttledAlarmHandler = useMemo(() => {
    return throttle((alarm) => {
      if (!alarm) return;
      // setAlarmPacket(alarm);
      /** Alarm is present then update alarm */
      if (entities[alarm.id]) {
        dispatch(refetchAlarmsData);
        return;
      }

      if (alarm.clear_dt) {
        dispatch(refetchAlarmsData);
        return;
      }

      /** New Alarm Generated show alert and sound notification */
      if (alarm.is_active && alarm.updated_dt === null) {
        playNotificationSound();
        toast((toastInfo) => <NewAlarmToast alarmInfo={alarm} dismiss={() => toast.dismiss(toastInfo.id)} />, {
          position: "top-right",
          duration: 8000,
          style: { maxWidth: "max-content" },
        });
        if (shouldInsertIntoTable({ alarm, filters })) {
          dispatch(refetchAlarmsData);
          return;
        }
      }
    },
    1000,
    { leading: true, trailing: true },
    )
  }, [dispatch, filters, entities, playAlarmSound]);

  useEffect(() => {
    let socket;
    const handelWebsocketAlarmMessage = (alarm) => {
      throttledAlarmHandler(alarm);
    };
    function websocketConnect() {
      const url = `${
        APP_BASE_URL_ALARM_SOCKET + ALARM_WEBSOCKET_PATH
      }/ALARMS?customer_ids=${customerIdList.toString()}`;
      socket = new WebSocket(url);
      socket.onmessage = (event) => {
        const alarm = JSON.parse(event.data);
        console.log("dfslkhgdjkfh", alarm);
        handelWebsocketAlarmMessage(alarm);
      };
      // socket.onclose = () => {
      //   console.log("connection closed");
      //   if (connect) {
      //     reconnectTimeout = setTimeout(function () {
      //       console.log("timeout called");
      //       websocketConnect();
      //     }, 1000);
      //   }
      // };
      socket.onerror = function () {
        socket.close();
      };
    }

    //for simlation
    let simulate_message_cnt = 1;
    let simulatior_interval;
    const alarmSimulator = () => {
      simulatior_interval = setInterval(() => {
        if (simulate_message_cnt % 2) {
          createAlarm();
        } else {
          clearAlarm();
        }
        simulate_message_cnt = simulate_message_cnt + 1;
      }, 5000);
    };
    //----------------------
    if (connect) {
      websocketConnect();
      // alarmSimulator();
    } else {
      if (socket) {
        socket.close();
        if (simulatior_interval) {
          clearInterval(simulatior_interval);
        }
      }
    }
    return () => {
      // console.log("closing socket");
      socket?.close();
      if (simulatior_interval) {
        clearInterval(simulatior_interval);
      }
      // clearTimeout(reconnectTimeout);
    };
  }, [connect, customerIdList.length]);
  // return { alarmPacket };
}
